import { REDUX_STORE_DEFAULTS } from "../config"

const initialState = {
  userData: {},
  sseConnection: false,
  // Add other variables here
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_STORE_DEFAULTS.UPDATE_LOGIN_USER():
      return {
        ...state,
        userData: action.payload,
      }
    case REDUX_STORE_DEFAULTS.UPDATE_SSE_CONNECTION():
      return {
        ...state,
        sseConnection: action.payload,
      }

    default:
      return state
  }
}

export default userReducer
